
  import { Vue, Component, Prop } from "vue-property-decorator";
  
  interface iContractors {
    name: string,
    id?: any
  }

  @Component
  export default class TableListChipNew extends Vue {
    @Prop({required: true,  type: Array}) readonly items!: any[];
    @Prop({default: 5, type: Number}) readonly limit!: number;
    @Prop(Boolean) readonly clickable!: boolean;

    get noContent () {
      return !this.items.length;
    }

    get itemsToRender() {
     return this.items.slice(0, this.limit);
    }

    get itemsMoreThanLimit(): boolean {
      return this.items.length > this.limit;
    }
  }
